import styled from "@emotion/styled";
import InputLabel from "@mui/material/InputLabel";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Layout from "components/structure/Layout";
import React, { useContext } from "react";
import { Button, Grid } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { SnackbarContext } from "context/snackBarContext";
import { AuthData } from "auth/AuthWarpper";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import lables from "utils/lables.json";

const ViewDetailsHierarchy = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = AuthData();

  const {
    id,
    levelCode,
    locationName,
    parentLocationCode,
    personName,
    batOneId,
    status,
    operation,
    errorDescription,
    locationCode,
    legacyCode,
    cropYear
  } = location.state || {};

  const { setOpenAlert, setSeverity, setMessage } = useContext(SnackbarContext);

  return (
    <Layout title={lables.pageTitle}>
      <div style={{ paddingBottom: "4rem" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          <Heading>          Import Hierarchy
          </Heading>
          <Button
            sx={{
              borderRadius: 100,
              minWidth: 95,
              minHeight: 44,
              background: "#102A62",
            }}
            variant="contained"
            startIcon={<KeyboardBackspaceIcon />}
            onClick={() => navigate(-1)}
          >
            {lables.backButton}
          </Button>
        </Box>
        <PaperContainer>
          <form autoComplete="off">
            <Grid container spacing={2}>
              <Grid
                item
                md={6}
                xs={12}
                sx={{
                  display: { md: "flex", sx: "block" },
                  alignItems: "center",
                }}
              >
                <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                  {lables.importFarmerViewDetails.operationLabel}
                </InputLabel>
                <Box>
                  <TextField
                    sx={{ width: { xs: "100%", md: "14rem" } }}
                    id="profileCode"
                    aria-describedby="my-helper-text"
                    label={""}
                    value={operation === null ? "null" : operation}
                    name="profileCode"
                    disabled={true}
                  />
                </Box>
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
                sx={{
                  display: { md: "flex", xs: "block" },
                  alignItems: "center",
                }}
              >
                <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                  {lables.statusPlaceholder}
                </InputLabel>
                <Box>
                  <TextField
                    sx={{ width: { xs: "100%", md: "14rem" } }}
                    id="profileCode"
                    aria-describedby="my-helper-text"
                    label={""}
                    value={status === null ? "null" : status}
                    name="profileCode"
                    disabled={true}
                  />
                </Box>
              </Grid>
              <Grid
                item
                md={12}
                xs={12}
                sx={{
                  display: { md: "flex" },
                  alignItems: "center",
                  flexDirection: "end",
                }}
              >
                <InputLabel sx={{ width: "10rem",
                  alignSelf: "flex-start" 
                 }} htmlFor="my-input">
                  {lables.importFarmerViewDetails.errorDesc}
                </InputLabel>
                <Box>
                  <TextField
                    sx={{ width: { xs: "100%", md: "1000px !important" } }}
                    id="profileCode"
                    aria-describedby="my-helper-text"
                    label={""}
                    value={
                      errorDescription === null ? "null" : errorDescription
                    }
                    name="profileCode"
                    disabled={true}
                    multiline
                    rows={4}
                  />
                </Box>
              </Grid>
            </Grid>
          </form>
        </PaperContainer>
        <Box sx={{ mt: 1 }}>
          <PaperContainer>
            <form autoComplete="off">
              <Grid container spacing={2}>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", sx: "block" },
                    alignItems: "center",
                  }}
                >
                  <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                    {lables.importFarmerViewDetails.levelCode}
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{ width: { xs: "100%", md: "14rem" } }}
                      id="profileCode"
                      aria-describedby="my-helper-text"
                      label={""}
                      value={levelCode === null ? "null" : levelCode}
                      name="profileCode"
                      disabled={true}
                    />
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", xs: "block" },
                    alignItems: "center",
                  }}
                >
                  <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                    {lables.importFarmerViewDetails.locationCode}
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{ width: { xs: "100%", md: "14rem" } }}
                      id="profileCode"
                      aria-describedby="my-helper-text"
                      label={""}
                      value={locationCode === null ? "null" : locationCode}
                      name="profileCode"
                      disabled={true}
                    />
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", xs: "none" },
                    alignItems: "center",
                    flexDirection: "end",
                  }}
                >
                  <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                    {lables.importFarmerViewDetails.locationName}
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{ width: { xs: "100%", md: "14rem" } }}
                      id="profileCode"
                      aria-describedby="my-helper-text"
                      label={""}
                      value={locationName === null ? "null" : locationName}
                      name="profileCode"
                      disabled={true}
                    />
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", sx: "block" },
                    alignItems: "center",
                  }}
                >
                  <InputLabel 
                  sx={{
                    width: "10rem",
                    whiteSpace: "normal",  
                    wordBreak: "break-word",
                  }}
                  htmlFor="my-input">
                    {lables.importFarmerViewDetails.parentLocationCo}
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{ width: { xs: "100%", md: "14rem" } }}
                      id="my-input"
                      aria-describedby="my-helper-text"
                      label={""}
                      value={parentLocationCode === null ? "" : parentLocationCode}
                      name="profileName"
                      disabled={true}
                    />
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", sx: "block" },
                    alignItems: "center",
                  }}
                >
                  <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                    {lables.importFarmerViewDetails.personName}

                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{ width: { xs: "100%", md: "14rem" } }}
                      id="my-input"
                      aria-describedby="my-helper-text"
                      label={""}
                      value={personName === null ? "null" : personName}
                      name="profileName"
                      disabled={true}
                    />
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", xs: "flex" },
                    alignItems: "center",
                    flexDirection: "end",
                  }}
                >
                  <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                    {lables.importFarmerViewDetails.batOneId}
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{ width: { xs: "100%", md: "14rem" } }}
                      id="my-input"
                      aria-describedby="my-helper-text"
                      label={""}
                      value={batOneId === null ? "" : batOneId}
                      name="profileName"
                      disabled={true}
                    />
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", xs: "flex" },
                    alignItems: "center",
                    flexDirection: "end",
                  }}
                >
                  <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                    {lables.importFarmerViewDetails.legacyCode}
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{ width: { xs: "100%", md: "14rem" } }}
                      id="my-input"
                      aria-describedby="my-helper-text"
                      label={""}
                      value={legacyCode === null ? "null" : legacyCode}
                      name="profileName"
                      disabled={true}
                    />
                  </Box>
                </Grid>
                <Grid
                  item
                  md={4}
                  xs={12}
                  sx={{
                    display: { md: "flex", xs: "flex" },
                    alignItems: "center",
                    flexDirection: "end",
                  }}
                >
                  <InputLabel sx={{ width: "10rem" }} htmlFor="my-input">
                    {lables.importFarmerViewDetails.cropYear}
                  </InputLabel>
                  <Box>
                    <TextField
                      sx={{ width: { xs: "100%", md: "14rem" } }}
                      id="my-input"
                      aria-describedby="my-helper-text"
                      label={""}
                      value={cropYear == null ? "" : cropYear}
                      name="profileName"
                      disabled={true}
                    />
                  </Box>
                </Grid>
              </Grid>
            </form>
          </PaperContainer>
        </Box>
      </div>
    </Layout>
  );
};

const Heading = styled.div`
  color: rgba(115, 125, 134, 1);
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
`;

const PaperContainer = styled(Paper)`
  padding: 2rem 1rem;
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin: 2rem 0;
`;

export default ViewDetailsHierarchy;
